import { jsx as r, jsxs as f } from "react/jsx-runtime";
import { Accordion as p } from "../Accordion/index.js";
import i from "./productCardFilesTab.module.js";
import { useTranslation as h } from "../../hooks/useTranslation.js";
import { AccessibleIcon as s } from "../Icon/index.js";
import { IconFile as u } from "../Icon/icons/IconFile.js";
import { isSupportedDocumentType as v } from "../../utils/utils.js";
const j = ({ assetResponse: o, ean: a, className: m }) => {
  var c, n;
  const { t: l, tryTranslate: t } = h();
  return /* @__PURE__ */ r("div", { className: m, children: /* @__PURE__ */ r(p, { header: l("files"), headingLevel: "h2", children: /* @__PURE__ */ r("div", { className: i.accordionContent, children: (n = (c = o == null ? void 0 : o[a]) == null ? void 0 : c.documents) == null ? void 0 : n.filter((e) => v(e.mediaType)).map((e, d) => /* @__PURE__ */ f("div", { className: i.fileLink, children: [
    /* @__PURE__ */ r(
      s,
      {
        svgIcon: /* @__PURE__ */ r(u, { color: "var(--orange-70)" }),
        label: l("file"),
        className: i.iconPad
      }
    ),
    /* @__PURE__ */ r(
      "a",
      {
        href: e.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: t(e.mediaType)
      }
    )
  ] }, d)) }) }) });
};
export {
  j as ProductCardFilesTab
};
